'use es6';

const hasScope = (auth, scope) => {
  return auth.user.scopes.includes(scope);
};

export const getHubSpotUserId = auth => auth.user.user_id;
export const showAdAccountLimits = auth => {
  // Uses ads-roi-reporting as a "proxy scope" for when the number of selectable accounts is "unlimited"
  return !hasScope(auth, 'ads-roi-reporting');
};